export class LocaleEvents {
  static localeChanged : string = "LocaleChanged";
}